<template>
  <v-footer padless fixed style="z-index: 6" class="pa-2">
    <v-spacer></v-spacer>
    {{ new Date().getFullYear() }} —
    <strong
      >&copy; Panel Depot / Developed by
      <a href="https://vizer.tech">VIZER</a></strong
    >
    <v-spacer></v-spacer>
  </v-footer>
</template>

<script>
export default {
  name: "Footer",
  components: {},
};
</script>

<style lang="scss">
a {
  text-decoration: none;

  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
}
</style>
